import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from '../../../shared/components/button/Button';
import LoadingSpinner from '../../../shared/components/UIElements/LoadingSpinner';
import { SignupContinueData } from '../types';
import { useSignupScreen3 } from './useSignupScreen3';

interface SignupScreen3Props {
  handleContinue: (dataObj: SignupContinueData) => void;
  error: string | undefined;
}

export function SignupScreen3({ handleContinue, error }: SignupScreen3Props) {
  const { t } = useTranslation();

  const {
    termsAccepted,
    isLoading,
    scrollableRef,
    buttonTriggerRef,
    handleContinue: handleContinueClick,
    handleTermsAcceptance,
    handleScroll,
  } = useSignupScreen3({ handleContinue });

  return (
    <>
      <h1>{t('R034')}</h1>
      <div className="terms-conditions-subtitle-container">
        <p className="terms-conditions-subtitle">
          {t('terms.conditions.subtitle.new')}
          {t('terms.conditions.subtitle.second')}{' '}
          <a
            href="https://support.championhealth.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            className="terms-conditions-subtitle-link"
            aria-label={`${t('terms.conditions.subtitle.link')} (opens in new window)`}
            data-testid="signup-terms-conditions-subtitle-link"
          >
            {t('terms.conditions.subtitle.link')}
          </a>
        </p>
      </div>
      <div className="tandc">
        <div
          ref={scrollableRef}
          id="scrollable"
          className="tandc_container"
          onScroll={handleScroll}
          tabIndex={0}
          role="region"
          aria-label="Terms and conditions content"
        >
          <p>
            {' '}
            <span>{t('R035v')}</span>
            <span> </span>
            <a
              href="https://www.championhealth.co.uk/legals/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Terms of Service (opens in new window)"
            >
              {t('R035aa')}
            </a>
            .
          </p>
          <p>
            {' '}
            <span>{t('R035a')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035b')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035c')}</span>
          </p>
          <p ref={buttonTriggerRef} id="button_trigger">
            {' '}
            <span>{t('R035d')}</span>
            <span> </span>{' '}
            <a
              href="https://www.championhealth.co.uk/legals/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Privacy Policy (opens in new window)"
            >
              {t('R035u')}
            </a>{' '}
            <span>{t('R035ab')}</span>{' '}
            <a
              href="https://support.championhealth.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Terms of Service (opens in new window)"
            >
              {t('R035aa')}
            </a>
            .
          </p>
          <p>
            <b>{t('R035e')}</b>
          </p>
          <p>
            {' '}
            <span>
              <Trans i18nKey="R035f" />
            </span>
          </p>
          <p>
            {' '}
            <span>{t('R035g')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035h')}</span>
          </p>
          <p>
            <b>{t('R035i')}</b>
          </p>
          <p>
            {' '}
            <span>{t('R035j')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035k')}</span>
            <a
              href="https://support.championhealth.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Support contact (opens in new window)"
            >
              {t('R035ac')}
            </a>
            .
          </p>
          <p>
            <b>{t('R035l')}</b>
          </p>
          <p>
            {' '}
            <span>{t('R035m')}</span>
          </p>
          <p style={{ paddingLeft: '10px' }}>
            {' '}
            <span>{t('R035n')}</span>
          </p>
          <p style={{ paddingLeft: '10px' }}>
            {' '}
            <span>{t('R035n1')}</span>
          </p>
          <p style={{ paddingLeft: '10px' }}>
            {' '}
            <span>{t('R035o')}</span>
          </p>
          <p style={{ paddingLeft: '10px' }}>
            {' '}
            <span>{t('R035o1')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035ad')}</span>{' '}
            <a
              href="https://www.championhealth.co.uk/legals/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Privacy Policy (opens in new window)"
            >
              {t('R035u')}
            </a>{' '}
            <span>{t('R035ae')}</span>
          </p>
          <p>
            <b>{t('R035r')}</b>
          </p>
          <p>
            {' '}
            <span>{t('R035s')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035t')}</span>
          </p>
          <p>
            <b>{t('R035q')}</b>
          </p>
          <p>
            {' '}
            <span>{t('R035w')}</span>
          </p>
          <p>
            <b>{t('R035x')}</b>
          </p>
          <p>
            {' '}
            <span>{t('R035y')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035z')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035af')}</span>
          </p>
          <p>
            {' '}
            <span>{t('R035ag')}</span>
          </p>{' '}
          <p>
            {' '}
            <span>{t('R035ah')}</span>
          </p>
        </div>
      </div>

      <div className="terms-acceptance-container">
        <label
          className="terms-checkbox-label"
          htmlFor="terms-acceptance"
          data-testid="signup-terms-acceptance-label"
        >
          <input
            type="checkbox"
            id="terms-acceptance"
            checked={termsAccepted}
            onChange={handleTermsAcceptance}
            className="terms-checkbox"
            aria-describedby="terms-description"
            data-testid="signup-terms-acceptance-checkbox"
          />
          <span className="terms-checkbox-text">{t('terms.conditions.acceptance.text')}</span>
        </label>
        <p id="terms-description" className="terms-description">
          {t('terms.conditions.acceptance.description')}
        </p>
      </div>
      {isLoading && <LoadingSpinner asOverlay />}
      {error && (
        <p className="login_error" role="alert">
          {' '}
          <FontAwesomeIcon icon={faTriangleExclamation} className="icon" />
          <span>{error}</span>
        </p>
      )}
      {!isLoading && (
        <Button
          onClick={handleContinueClick}
          id="continue"
          className={termsAccepted ? 'accepted' : 'declined'}
          isDisabled={!termsAccepted}
          aria-describedby={!termsAccepted ? 'terms-description' : undefined}
          dataTestId="signup-continue-button"
        >
          {t('R053')}
        </Button>
      )}
    </>
  );
}
